import { contractSelectors } from 'store/contract';
import { skillSelectors } from 'store/skill';
import { Employee } from 'domain/Employee';
import DomainObjectView from 'domain/DomainObjectView';
import { Map } from 'immutable';
import { AppState } from '../types';

export const getEmployeeById = (state: AppState, id: number): Employee => {
  if (state.employeeList.isLoading || state.skillList.isLoading || state.contractList.isLoading) {
    return null as any;
  }
  const employeeView = state.employeeList.employeeMapById.get(id) as DomainObjectView<Employee>;
  return {
    ...employeeView,
    skillProficiencySet: employeeView.skillProficiencySet.map((skillId) => skillSelectors.getSkillById(state, skillId)),
    contract: contractSelectors.getContractById(state, employeeView.contract),
  };
};

let oldEmployeeMapById: Map<number, DomainObjectView<Employee>> | null = null;
let employeeListForOldEmployeeMapById: Employee[] | null = null;

export const getEmployeeList = (state: AppState): Employee[] => {
  if (state.employeeList.isLoading || state.skillList.isLoading || state.contractList.isLoading) {
    return [];
  }
  if (oldEmployeeMapById === state.employeeList.employeeMapById && employeeListForOldEmployeeMapById !== null) {
    return employeeListForOldEmployeeMapById;
  }

  const out = state.employeeList.employeeMapById.keySeq().map((id) => getEmployeeById(state, id))
    .sortBy((employee) => employee.name).toList();

  oldEmployeeMapById = state.employeeList.employeeMapById;
  employeeListForOldEmployeeMapById = out.toArray();
  return employeeListForOldEmployeeMapById;
};

let oldActiveEmployeeMapById: Map<number, DomainObjectView<Employee>> | null = null;
let employeeListForOldActiveEmployeeMapById: Employee[] | null = null;

export const getActiveEmployeeList = (state: AppState): Employee[] => {
  if (state.employeeList.isLoading || state.skillList.isLoading || state.contractList.isLoading) {
    return [];
  }
  if (oldActiveEmployeeMapById === state.employeeList.employeeMapById && employeeListForOldActiveEmployeeMapById !== null) {
    return employeeListForOldActiveEmployeeMapById;
  }

  const out = state.employeeList.employeeMapById.keySeq().map((id) => getEmployeeById(state, id))
    .filter((employee) => employee.status).sortBy((employee) => employee.name).toList();

  oldActiveEmployeeMapById = state.employeeList.employeeMapById;
  employeeListForOldActiveEmployeeMapById = out.toArray();
  return employeeListForOldActiveEmployeeMapById;
};
